import { useTranslation } from 'react-i18next';
import { Info, Lock, Search, TriangleAlert } from 'lucide-react';

import type { TableEmptyState } from '../types';

import { cn } from '@/lib/utils';

const STATES = {
  empty: {
    icon: Info,
    title: 'No Data Provided',
    description: 'Records will appear here once they are added.',
  },
  search: {
    icon: Search,
    title: 'Nothing found',
    description: 'Try changing your search or filters.',
  },
  error: {
    icon: TriangleAlert,
    title: 'Failed to load data',
    description: 'Try refreshing the page.',
  },
  forbidden: {
    icon: Lock,
    title: 'No access',
    description: 'You do not have permission to view this data.',
  },
};

type EmptyTableProps = {
  state?: TableEmptyState;
};

export const EmptyTable = (props: EmptyTableProps) => {
  const { state = 'empty' } = props;
  const { t } = useTranslation();
  const { icon: Icon, title, description } = STATES[state];
  const isError = state === 'error';

  return (
    <div className="flex flex-col items-center gap-1.5 px-4 py-8 text-center whitespace-normal">
      <span
        className={cn(
          'mb-1 flex size-9 items-center justify-center rounded-lg',
          isError
            ? 'bg-destructive-soft text-destructive-soft-foreground'
            : 'bg-muted text-muted-foreground',
        )}
      >
        <Icon className="size-4.5" />
      </span>
      <span className="text-foreground text-sm font-semibold">{t(title)}</span>
      <span className="text-muted-foreground text-xs">{t(description)}</span>
    </div>
  );
};
